function isTabletWidth() {
  return $('.mediaquery--tablet').is(':visible');
}
